import React from 'react'
import { IconButton, Tooltip } from '@mui/material'

export const IconButtonComponent = ({ title, placement, onClick, children }) => {
  return (
    <Tooltip title={title} placement={placement ?? "bottom"}>
      <IconButton onClick={onClick}>
        {children}
      </IconButton>
    </Tooltip>
  )
}

export const IconComponent = ({ title, children }) => {
  return (
    <Tooltip title={title}>
      <div>
        {children}
      </div>
    </Tooltip>
  )
}
